<template>
  <div>
    <div class="mt-4">
      <!-- {{ select_pump }} -->
      <!-- <pre>{{ option_pump }}</pre> -->
      <ul class="non-list box1_t1">
        <li><h1 class="text-box1">Power consumption</h1></li>

        <br />
        <li style="display: flex; align-items: center">
          <h4 class="mr-1">Select Pump :</h4>
          <vs-select @change="logdata" v-model="select_pump">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in option_pump"
            />
          </vs-select>
        </li>
        <!-- <br /> -->
      </ul>
    </div>

    <div style="display: flex; position: relative">
      <div style="width: 20%">
        <img src="@/assets/images/NikhomLatKrabang/wind.gif" class="sizet2" />
      </div>
      <div style="width: 80%">
        <ul class="non-list box1_t1">
          <li>
            <h1 class="text-box2">
              {{ result_value[get_data.key1] }} <sub> kWh</sub>
            </h1>
          </li>
        </ul>
        <br />
        <div class="box1_t2 mr-4">
          <ul class="non-list">
            <li>
              <h5>
                Monthy Volume
                <a class="text-w">{{ result_value[get_data.key2] }}</a> kWh
              </h5>
            </li>
            <li class="mt-4">
              <h5>
                Yearly Volume
                <a class="text-w">{{ result_value[get_data.key3] }}</a> kWh
              </h5>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["select_pump", "option_pump", "result_value"],
  data() {
    return {
      get_data: [],
      data: [
        {
          id: 1,
          power_consumption: 293.86,
          value_year: 1020,
          value_month: 103,
        },
        {
          id: 2,
          power_consumption: 193.81,
          value_year: 1120,
          value_month: 203,
        },
        {
          id: 3,
          power_consumption: 113.81,
          value_year: 1720,
          value_month: 603,
        },
      ],
    };
  },
  methods: {
    logdata() {
      // console.log(a);
      this.get_data = this.option_pump[this.select_pump];
      // this.logdata_2(this.select_pump);
      this.$emit("fSelect_pump", this.get_data);
    },
    // select_pump(value) {
    //   this.maxminTemp = value;
    // },
  },
  created() {
    // this.get_data = this.option_pump[this.select_pump];
    this.logdata();
  },
};
</script>

<style scoped>
.non-list {
  list-style: none;
}
.box1_t1 {
  display: grid;
  justify-items: center;
}
.box1_t2 {
  display: flex;
  justify-content: flex-end;
}
.sizet2 {
  width: 30%;
  position: absolute;
  left: 0;
  bottom: 0;
}
.text-box1 {
  /* font-size: 2vw; */
  white-space: nowrap;
  font-weight: 600;
  color: #707070;
}

.text-box2 {
  /* font-size: 2.5vw; */
  font-size: calc(1rem + 2vw);
  white-space: nowrap;
  font-weight: 600;
  color: #707070;
}
@media only screen and (max-width: 700px) {
  .text-box1 {
    font-size: 2rem;
  }
}
</style>